import React from 'react'
import Svg from '../../SvgComponent/Svg'
import { SvgProps } from '../../SvgComponent/types'

const WalletIcon: React.FC<SvgProps> = ({ width, height, color, ...props }) => {
  return (
    <Svg {...props} width={width || '20px'} height={height || '20px'} viewBox="0 0 20 20" color="none">
      <g id="wallet custom">
        <path
          id="Vector"
          d="M1.6665 5C1.6665 5.66304 1.94087 6.29893 2.42925 6.76777C2.91762 7.23661 3.58 7.5 4.27067 7.5H18.3332"
          stroke={color || 'white'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M4.27067 18.3333H18.3332V7.49998H13.6457V2.49998H4.27067C3.58 2.49998 2.91762 2.78306 2.42925 3.28694C1.94087 3.79082 1.6665 4.47423 1.6665 5.18683V15.6465C1.6665 16.3591 1.94087 17.0425 2.42925 17.5464C2.91762 18.0502 3.58 18.3333 4.27067 18.3333Z"
          stroke={color || 'white'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector 2"
          d="M10.8335 12.5L14.1668 12.5"
          stroke={color || 'white'}
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
    </Svg>
  )
}

export default WalletIcon
